import React from 'react';

import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditIcon from '@material-ui/icons/Edit';
import MuiSaveIcon from '@material-ui/icons/Save';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

import { WithTooltip } from 'utils/wrappers';

function RowButtons({ editing, onEditChange, onSave, inProgress, invalid }) {
  const handleEditClick = () => onEditChange(true);
  const handleCancelClick = () => {
    onEditChange(false);
  };

  const ActionSave = (
    <WithTooltip tooltip="Save Changes" disabled={invalid}>
      <MuiIconButton onClick={onSave}>
        <MuiSaveIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionCancel = (
    <WithTooltip tooltip="Cancel">
      <MuiIconButton onClick={handleCancelClick}>
        <MuiBlockIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionInProgress = (
    <MuiIconButton disabled={true}>
      <MuiCircularProgress size={'1rem'} />
    </MuiIconButton>
  );

  return (
    <>
      {!editing ? (
        <>
          <WithTooltip tooltip="Edit Splits" key="edit">
            <MuiIconButton onClick={handleEditClick}>
              <MuiEditIcon />
            </MuiIconButton>
          </WithTooltip>
        </>
      ) : (
        <>
          {inProgress ? ActionInProgress : ActionSave}
          {ActionCancel}
        </>
      )}
    </>
  );
}

export default RowButtons;
